import styled from 'styled-components';

export const Wrap = styled.div`
  position: relative;
  background-color: white;
`;
